import Vue from 'vue';
import Router from 'vue-router';
// import Home from './views/Home.vue';

Vue.use(Router);

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

export default new Router({
  routes: [
    // {
    //   path: '/',
    //   name: 'rescue',
    //   component: () => import('@/views/rescue.vue'),
    //   meta: {
    //     // keepAlive: true,
    //   },
    // },
    // {
    //   path: '/rescueOrder',
    //   name: 'rescueOrder',
    //   component: () => import('@/views/rescue-order.vue'),
    //   meta: {
    //     // keepAlive: true,
    //   },
    // },
    {
      path: '/viewOrder',
      name: 'viewOrder',
      component: () => import('@/views/view-order.vue'),
      meta: {
        // keepAlive: true,
      }
    },
    {
      path: '/rescueAgreement',
      name: 'rescueAgreement',
      component: () => import('@/views/rescue-agreement.vue'),
      meta: {
        // keepAlive: true,
      }
    },
    {
      path: '/orderResult',
      name: 'orderResult',
      component: () => import('@/views/order-result.vue'),
      meta: {
        // keepAlive: true,
      }
    },
    {
      path: '/rescueOrder',
      name: 'rescueOrder',
      component: () => import('@/views/rescue-order-price.vue'),
      meta: {
        keepAlive: true
      }
    },
    // {
    //   path: '/rescueEnd',
    //   name: 'rescueEnd',
    //   component: () => import('@/views/rescueEnd.vue'),
    // },
    // {
    //   path: '/rescueStart',
    //   name: 'rescueStart',
    //   component: () => import('@/views/rescueStart.vue')
    // },
    // {
    //   path: '/rescueSelectAddress',
    //   name: 'rescueSelectAddress',
    //   component: () => import('@/views/rescueSelectAddress.vue'),
    // },
    {
      //   //中银身份验证页面
      path: '/login',
      name: 'login',
      component: () => import('@/views/login.vue'),
      meta: {
        hidden: true,
        keepAlive: true,
        title: '身份验证'
      }
    },
    {
      // 中银无车辆列表页面
      path: '/listing',
      name: 'listing',
      component: () => import('@/views/listing.vue'),
      meta: {
        hidden: true,
        keepAlive: true,
        title: '车辆列表'
      }
    },
    {
      // 中银添加车辆列表页面
      path: '/addListing',
      name: 'addListing',
      component: () => import('@/views/addListing.vue'),
      meta: {
        hidden: true,
        keepAlive: false,
        title: '添加车辆'
      }
    },
    {
      // 中银权益页面
      path: '/interests',
      name: 'interests',
      component: () => import('@/views/interests.vue'),
      meta: {
        hidden: true,
        keepAlive: true,
        title: '查询权益'
      }
    },
    {
      // 订单详情
      path: '/orderDetail',
      name: 'orderDetail',
      component: () => import('@/views/order/order-detail.vue'),
      meta: {
        title: '订单详情'
      }
    },
    {
      // 门店列表
      path: '/storeList',
      name: 'storeList',
      component: () => import('@/views/order/store-list.vue'),
      meta: {
        title: '门店列表'
      }
    },
    {
      // 客户告知函
      path: '/userAgreement',
      name: 'userAgreement',
      component: () => import('@/views/user-agreement.vue'),
      meta: {
        title: '客户告知函'
      }
    },
    // // 上线年检取送车推广页
    // {
    //   path: '/promotionVehicleInspection/:id',
    //   name: 'promotionVehicleInspection',
    //   component: () => import('@/views/promotion/vehicle-inspection/index.vue'),
    //   meta: {
    //     title: '上线年检-上门取送车',
    //     keepAlive: true,
    //   },
    //   beforeEnter: (to, from, next) => {
    //     // 校验活动有效期, 实际有效期至2021-8-31
    //     const end = new Date('2021-9-1')
    //     if (Date.now() > end.getTime()) {
    //       return next({ name: 'promotionExpired' })
    //     }

    //     next()
    //   },
    // },
    {
      path: '/address',
      name: 'address',
      component: () =>
        import('@/views/promotion/vehicle-inspection/address.vue'),
      meta: {
        title: '取送车地址'
      }
    },
    // {
    //   path: '/inspectionStores',
    //   name: 'inspectionStores',
    //   component: () => import('@/views/promotion/vehicle-inspection/stores.vue'),
    //   meta: {
    //     title: '选择门店'
    //   }
    // },
    // {
    //   path: '/appointmentSuccess',
    //   name: 'appointmentSuccess',
    //   component: () => import('@/views/promotion/vehicle-inspection/success.vue'),
    //   meta: {
    //     title: '预约成功',
    //   },
    // },
    // {
    //   path: '/promotionExpired',
    //   name: 'promotionExpired',
    //   component: () => import('@/views/promotion/vehicle-inspection/expiration.vue'),
    //   meta: {
    //     title: '活动结束',
    //   },
    // },

    // 车生活
    // 车生活-手机充值
    {
      path: '/',
      name: 'carLifeLogin',
      component: () => import('@/views/car-life-login.vue'),
      meta: {
        title: '登录'
      }
    },
    {
      path: '/carLife',
      name: 'carLife',
      component: () => import('@/views/car-life.vue'),
      meta: {
        title: '车生活'
      }
    },
    {
      path: '/phoneCharge',
      name: 'phoneCharge',
      component: () => import('@/views/phone-charge/phone-charge.vue'),
      meta: {
        title: '手机充值'
      }
    },
    {
      path: '/phoneChargeRecords',
      name: 'phoneChargeRecords',
      component: () => import('@/views/phone-charge/records.vue'),
      meta: { title: '充值记录' }
    },
    {
      path: '/phoneChargeDetail',
      name: 'phoneChargeDetail',
      props: true,
      component: () => import('@/views/phone-charge/detail.vue'),
      meta: { title: '充值详情' }
    },
    {
      path: '/refuelRecharge',
      name: 'refuelRecharge',
      component: () => import('@/views/refuel/recharge.vue'),
      meta: {
        title: '加油卡充值'
      }
    },
    {
      path: '/newCard',
      name: 'newCard',
      component: () => import('@/views/refuel/new-card.vue'),
      meta: {
        title: '加油卡充值'
      }
    },
    {
      path: '/giftRecord',
      name: 'giftRecord',
      component: () => import('@/views/giftcard/gift-record.vue'),
      meta: {
        title: '充值记录'
      }
    },
    {
      path: '/resultPage',
      name: 'resultPage',
      component: () => import('@/views/giftcard/result-page2.vue'),
      meta: {
        title: '支付结果'
      }
    },
    {
      path: '/giftSelectProduct',
      name: 'giftSelectProduct',
      component: () => import('@/views/giftcard/select-product.vue'),
      meta: {
        title: '礼品卡充值'
      }
    },
    {
      path: '/giftRecharge',
      name: 'giftRecharge',
      component: () => import('@/views/giftcard/gift-recharge.vue'),
      meta: {
        title: '礼品卡充值'
      }
    },
    {
      path: '/giftOrderDetail',
      name: 'giftOrderDetail',
      component: () => import('@/views/giftcard/order-detail.vue'),
      meta: {
        title: '订单详情'
      }
    },
    {
      path: '/mediaOrderDetail',
      name: 'mediaOrderDetail',
      component: () => import('@/views/mediaCard/order-detail.vue'),
      meta: {
        title: '订单详情'
      }
    },
    {
      path: '/refuelRecord',
      name: 'refuelRecord',
      component: () => import('@/views/refuel/refuel-record.vue'),
      meta: {
        title: '充值记录'
      }
    },
    {
      path: '/refuelDetail',
      name: 'refuelDetail',
      component: () => import('@/views/refuel/refuel-detail.vue'),
      meta: {
        title: '充值记录'
      }
    },
    // 车生活-一键加油
    {
      path: '/akeyRefuel',
      name: 'akeyRefuel',
      component: () => import('@/views/akeyRefuel/akey-refuel.vue'),
      meta: {
        title: '一键加油'
      }
    },
    {
      path: '/payRecord',
      name: 'payRecord',
      component: () => import('@/views/akeyRefuel/pay-record.vue'),
      meta: {
        title: '付款记录'
      }
    },
    {
      path: '/mediaCharge',
      name: 'mediaCharge',
      component: () => import('@/views/mediaCard/card-charge.vue'),
      meta: {
        title: '视听卡充值'
      }
    },
    {
      path: '/mediaRecord',
      name: 'mediaRecord',
      component: () => import('@/views/mediaCard/media-record.vue'),
      meta: {
        title: '视听卡充值'
      }
    },
    {
      path: '/chargeView',
      name: 'chargeView',
      component: () => import('@/views/mediaCard/charge-view.vue'),
      meta: {
        title: '视听卡充值'
      }
    },
    {
      path: '/surveyReport',
      name: 'surveyReport',
      component: () => import('@/views/surveyReport.vue'),
      meta: {
        title: '风勘报告',
        keepAlive: true
      }
    },
    {
      path: '/startSign',
      name: 'startSign',
      component: () => import('@/views/start-sign.vue'),
      meta: {
        title: '签名'
      }
    },
    {
      path: '/ticket',
      name: 'ticket',
      component: () => import('@/views/ticket/index.vue'),
      meta: {
        title: '违章代办'
      }
    },
    {
      path: '/ticketCheck',
      name: 'ticketCheck',
      component: () => import('@/views/ticket/ticketCheck.vue'),
      meta: {
        title: '罚单缴费'
      }
    },
    {
      path: '/ticketPay',
      name: 'ticketPay',
      component: () => import('@/views/ticket/ticketPay.vue'),
      meta: {
        title: '罚单缴费'
      }
    },
    {
      path: '/commonProblem',
      name: 'commonProblem',
      component: () => import('@/views/ticket/commonProblem.vue'),
      meta: {
        title: '常见问题'
      }
    },
    {
      path: '/orderList',
      name: 'orderList',
      component: () => import('@/views/ticket/orderList.vue'),
      meta: {
        title: '我的订单'
      }
    },
    {
      path: '/ticketOrderDetail',
      name: 'ticketOrderDetail',
      component: () => import('@/views/ticket/orderDetail.vue'),
      meta: {
        title: '我的订单'
      }
    },
    {
      path: '/carCheck',
      name: 'carCheck',
      component: () => import('@/views/ticket/carCheck.vue'),
      meta: {
        title: '违章缴费'
      }
    },
    {
      path: '/parkingViolationsCheck',
      name: 'parkingViolationsCheck',
      component: () => import('@/views/ticket/parkingViolationsCheck.vue'),
      meta: {
        title: '违章缴费'
      }
    },
    {
      path: '/parkingViolationsPay',
      name: 'parkingViolationsPay',
      component: () => import('@/views/ticket/parkingViolationsPay.vue'),
      meta: {
        title: '违章缴费'
      }
    },
    {
      path: '/pvOrderDetail',
      name: 'pvOrderDetail',
      component: () => import('@/views/ticket/pvOrderDetail.vue'),
      meta: {
        title: '我的订单'
      }
    },
    {
      path: '/privacyPolicy',
      name: 'privacyPolicy',
      component: () => import('@/views/phone-charge/word/privacy-policy.vue'),
      meta: {
        title: '个人信息保护隐私政策'
      }
    },
    {
      path: '/processingRules',
      name: 'processingRules',
      component: () => import('@/views/phone-charge/word/processing-rules.vue'),
      meta: {
        title: '个人客户信息处理规则'
      }
    },
    {
      path: '/licenseAgreement',
      name: 'licenseAgreement',
      component: () =>
        import('@/views/phone-charge/word/license-agreement.vue'),
      meta: {
        title: '个人信息处理授权协议'
      }
    },
    {
      path: '/paicOrder/index/:orderNo/:taskNo',
      name: 'paicOrder',
      component: () => import('@/views/paicOrder/index.vue'),
      meta: {
        title: '任务执行',
        keepAlive: true
      }
    },
    {
      path: '/paicOrder/evacuation/:orderNo/:taskNo',
      name: 'evacuation',
      component: () => import('@/views/paicOrder/evacuation.vue'),
      meta: {
        title: '放空',
        keepAlive: true
      }
    },
    {
      path: '/paicOrder/executed/:orderNo/:taskNo',
      name: 'executed',
      component: () => import('@/views/paicOrder/executed.vue'),
      meta: {
        title: '执行完成'
      }
    },
    {
      path: '/workOrders/:orderNo/:taskNo',
      name: 'WorkOrders',
      component: () =>
        import('@/views/generalOrder/roadOrDistressRescue/workOrders.vue'),
      meta: {
        title: '电子工单',
        keepAlive: true
      }
    },
    {
      path: '/paicOrder/trailCompleted/:orderNo/:taskNo',
      name: 'trailCompleted',
      component: () => import('@/views/paicOrder/trailCompleted.vue'),
      meta: {
        title: '拖车结束',
        keepAlive: true
      }
    },
    {
      path: '/accidentRescue/login',
      name: 'accidentRescueLogin',
      component: () => import('@/views/accidentRescue/login.vue'),
      meta: {
        title: '登录'
      }
    },
    {
      path: '/accidentRescue/autoLogin/:token',
      name: 'AccidentRescueAutoLogin',
      component: () => import('@/views/accidentRescue/autoLogin.vue'),
      meta: {
        title: '自动登录'
      }
    },
    {
      path: '/accidentRescue/list',
      name: 'accidentRescueList',
      component: () => import('@/views/accidentRescue/list.vue'),
      meta: {
        title: '事故救援'
      }
    },
    {
      path: '/accidentRescue/edit',
      name: 'accidentRescueEdit',
      component: () => import('@/views/accidentRescue/edit.vue'),
      meta: {
        title: '新增订单'
      }
    },
    {
      path: '/accidentRescue/add',
      name: 'accidentRescueAdd',
      component: () => import('@/views/accidentRescue/add.vue'),
      meta: {
        title: '新增订单'
      }
    },
    {
      path: '/accidentRescue/detail',
      name: 'accidentRescueDetail',
      component: () => import('@/views/accidentRescue/detail.vue'),
      meta: {
        title: '订单详情'
      }
    },
    {
      path: '/accidentRescue/map',
      name: 'accidentRescueMap',
      component: () => import('@/views/accidentRescue/map.vue'),
      meta: {
        title: '选择位置'
      }
    },
    {
      path: '/generalOrder/landing/:taskNo/:tokenKey',
      name: 'GeneralOrderLanding',
      component: () => import('@/views/generalOrder/landing.vue'),
      meta: {
        title: '正在跳转...' // 公共订单流程中转页
      }
    },
    {
      path: '/generalOrder',
      name: 'GeneralOrder',
      component: () => import('@/views/generalOrder/index.vue'),
      meta: {
        title: '订单详情'
      },
      children: [
        {
          path: 'waitService/:orderNo/:taskNo',
          name: 'GeneralOrderWaitService',
          component: () =>
            import(
              '@/views/generalOrder/roadOrDistressRescue/waitServiceOrArrive.vue'
            ),
          meta: {
            title: '待服务'
          }
        },
        {
          path: 'waitArrive/:orderNo/:taskNo',
          name: 'GeneralOrderWaitArrive',
          component: () =>
            import(
              '@/views/generalOrder/roadOrDistressRescue/waitServiceOrArrive.vue'
            ),
          meta: {
            title: '待到达现场'
          }
        },
        {
          path: 'taskExecution/:orderNo/:taskNo',
          name: 'GeneralOrderTaskExecution',
          component: () =>
            import(
              '@/views/generalOrder/roadOrDistressRescue/taskExecution.vue'
            ),
          meta: {
            title: '任务执行',
            keepAlive: true
          }
        },
        {
          path: 'evacuation/:orderNo/:taskNo',
          name: 'GeneralOrderEvacuation',
          component: () =>
            import('@/views/generalOrder/roadOrDistressRescue/evacuation.vue'),
          meta: {
            title: '放空',
            keepAlive: true
          }
        },
        {
          path: 'trailing/:orderNo/:taskNo',
          name: 'GeneralOrderTrailing',
          component: () =>
            import('@/views/generalOrder/roadOrDistressRescue/trailing.vue'),
          meta: {
            title: '正在拖车'
          }
        },
        {
          path: 'trailCompleted/:orderNo/:taskNo',
          name: 'GeneralOrderTrailCompleted',
          component: () =>
            import(
              '@/views/generalOrder/roadOrDistressRescue/trailCompleted.vue'
            ),
          meta: {
            title: '拖车结束',
            keepAlive: true
          }
        },
        {
          path: 'executed/:orderNo/:taskNo',
          name: 'GeneralOrderExecuted',
          component: () =>
            import('@/views/generalOrder/roadOrDistressRescue/executed.vue'),
          meta: {
            title: '执行完成'
          }
        },
        {
          path: 'cancelOrder/:fromPage/:orderNo/:taskNo',
          name: 'GeneralOrderCancelOrder',
          component: () =>
            import('@/views/generalOrder/roadOrDistressRescue/cancelOrder.vue'),
          meta: {
            title: '取消订单',
            keepAlive: true
          }
        },
        {
          path: 'certificate',
          name: 'GeneralOrderCertificate',
          component: () =>
            import('@/views/generalOrder/roadOrDistressRescue/certificate.vue'),
          meta: {
            title: '照片'
          }
        },
        {
          path: 'reAudit/:orderNo/:taskNo',
          name: 'GeneralOrderReAudit',
          component: () =>
            import('@/views/generalOrder/roadOrDistressRescue/reAudit.vue'),
          meta: {
            title: '任务详情',
            keepAlive: true
          }
        },
        {
          path: 'orderDetail/:orderNo/:taskNo',
          name: 'GeneralOrderDetail',
          component: () =>
            import('@/views/generalOrder/roadOrDistressRescue/orderDetail.vue'),
          meta: {
            title: '任务详情',
            keepAlive: true
          }
        },
        {
          path: 'accidentRescue/:orderNo/:taskNo',
          name: 'GeneralOrderAccidentRescue',
          component: () =>
            import('@/views/generalOrder/accidentRescue/index.vue'),
          meta: {
            title: '待服务',
            keepAlive: true
          }
        },
        {
          path: 'workOrders/:orderNo/:taskNo',
          name: 'GeneralOrderWorkOrders',
          component: () =>
            import(
              '@/views/generalOrder/roadOrDistressRescue/workOrdersH5.vue'
            ),
          meta: {
            title: '电子工单',
            keepAlive: true
          }
        },
        {
          path: 'sign',
          name: 'Sign',
          component: () =>
            import('@/views/generalOrder/roadOrDistressRescue/sign.vue'),
          meta: {
            title: '签名'
          }
        }
      ]
    },
    {
      path: '/orderReport',
      name: 'OrderReport',
      component: () => import('./views/orderReport'),
      redirect: '/orderReport/base',
      children: [
        {
          path: 'base/:orderNo/:taskNo',
          name: 'OrderReportBase',
          component: () => import('./views/orderReport/orderReportPage/orderReportBase.vue'),
          meta: {
            title: '在线报备'
          }
        },
        {
          path: 'create/:orderNo/:taskNo',
          name: 'OrderReportCreate',
          component: () => import('./views/orderReport/orderReportPage/orderReportCreate.vue'),
          meta: {
            title: '提交报备'
          }
        },
        {
          path: 'detail/:orderNo/:taskNo',
          name: 'OrderReportDetail',
          component: () => import('./views/orderReport/orderReportPage/orderReportDetail.vue'),
          meta: {
            title: '报备详情'
          }
        },
        {
          path: 'appBase/:orderNo/:taskNo',
          name: 'OrderReportAppBase',
          component: () => import('./views/orderReport/orderReportPage/orderReportBase.vue'),
          meta: {
            title: '在线报备'
          }
        },
        {
          path: 'appCreate/:orderNo/:taskNo',
          name: 'OrderReportAppCreate',
          component: () => import('./views/orderReport/orderReportPage/orderReportCreate.vue'),
          meta: {
            title: '提交报备'
          }
        },
        {
          path: 'appDetail/:orderNo/:taskNo',
          name: 'OrderReportAppDetail',
          component: () => import('./views/orderReport/orderReportPage/orderReportDetail.vue'),
          meta: {
            title: '报备详情'
          }
        }
      ]
    },
    {
      path: '/sharedList',
      name: 'SharedList',
      component: () => import('@/views/appProtocol/shared-list.vue'),
      meta: {
        title: '第三方信息共享清单'
      }
    },
    {
      path: '/thirdSdk',
      name: 'ThirdSdk',
      component: () => import('@/views/appProtocol/third-sdk.vue'),
      meta: {
        title: '第三方SDK目录'
      }
    },
    {
      path: '/personInfoList',
      name: 'PersonInfoList',
      component: () => import('@/views/appProtocol/personInfoList.vue'),
      meta: {
        title: '个人信息收集清单'
      }
    },
    {
      path: '/privacy',
      name: 'Privacy',
      component: () => import('@/views/appProtocol/privacy.vue'),
      meta: {
        title: '隐私政策'
      }
    },
    {
      path: '/sharedListAii',
      name: 'SharedListAii',
      component: () => import('@/views/appProtocol/shared-list-aii.vue'),
      meta: {
        title: '第三方信息共享清单'
      }
    },
    {
      path: '/sharedListZbcf',
      name: 'SharedListZbcf',
      component: () => import('@/views/appProtocol/shared-list-zbcf.vue'),
      meta: {
        title: '第三方信息共享清单'
      }
    },
    {
      path: '/bociProtocol',
      name: 'BociProtocol',
      component: () => import('@/views/boci-protocol.vue'),
      meta: {
        title: '中银保险有限公司车险网络平台隐私政策'
      }
    },
    {
      path: '/chargingVoucher',
      name: 'ChargingVoucher',
      component: () => import('@/components/PageComponent.vue'),
      redirect: {
        name: 'ChargingVoucherCenter'
      },
      meta: {
        title: '充电服务'
      },
      children: [
        {
          path: 'home',
          name: 'ChargingVoucherCenter',
          component: () =>
            import('@/views/chargingVoucher/chargingVoucherCenter.vue'),
          meta: {
            title: '购券中心'
          }
        },
        {
          path: 'shareCode',
          name: 'ChargingVoucherShareCode',
          component: () => import('@/views/chargingVoucher/shareCode.vue'),
          meta: {
            title: '我的分享码'
          }
        },
        {
          path: 'shareCodePost',
          name: 'ChargingVoucherShareCodePost',
          component: () => import('@/views/chargingVoucher/shareCodePost.vue'),
          meta: {
            title: '长按图片保存'
          }
        },
        {
          path: 'myRecruitment',
          name: 'ChargingVoucherMyRecruitment',
          component: () => import('@/views/chargingVoucher/myRecruitment.vue'),
          meta: {
            title: '我的拉新'
          }
        },
        {
          path: 'myScore',
          name: 'ChargingVoucherMyScore',
          component: () => import('@/views/chargingVoucher/myScore.vue'),
          meta: {
            title: '我的积分'
          }
        },
        {
          path: 'myEarnings',
          name: 'ChargingVoucherMyEarnings',
          component: () => import('@/views/chargingVoucher/myEarnings.vue'),
          meta: {
            title: '我的钱包'
          }
        },
        {
          path: 'myOrder',
          name: 'ChargingVoucherMyOrder',
          component: () => import('@/views/chargingVoucher/myOrder.vue'),
          meta: {
            title: '我的订单'
          }
        },
        {
          path: 'specialCoupon',
          name: 'ChargingVoucherSpecialCoupon',
          component: () =>
            import('@/views/chargingVoucher/specialCoupon.vue'),
          meta: {
            title: '特惠券包'
          }
        },
        {
          path: 'adPage',
          name: 'ChargingVoucherAgencyAdPage',
          component: () =>
            import('@/views/chargingVoucher/adPage.vue'),
          meta: {
            title: '广告页'
          }
        }
      ]
    },
    {
      path: '/chargingVoucherAgency',
      name: 'ChargingVoucherAgency',
      component: () => import('@/components/PageComponent.vue'),
      redirect: {
        name: 'ChargingVoucherAgencyCenter'
      },
      meta: {
        title: '充电服务'
      },
      children: [
        {
          path: 'home',
          name: 'ChargingVoucherAgencyCenter',
          component: () =>
            import('@/views/chargingVoucherAgency/chargingVoucherCenter.vue'),
          meta: {
            title: '购券中心'
          }
        },
        {
          path: 'shareCodePost',
          name: 'ChargingVoucherAgencyShareCodePost',
          component: () =>
            import('@/views/chargingVoucherAgency/shareCodePost.vue'),
          meta: {
            title: '长按图片保存'
          }
        },
        {
          path: 'defaultBlank',
          name: 'ChargingVoucherAgencyDefaultBlank',
          component: () =>
            import('@/views/chargingVoucherAgency/defaultBlank.vue'),
          meta: {
            title: '默认页'
          }
        },
        {
          path: 'specialCoupon',
          name: 'ChargingVoucherAgencySpecialCoupon',
          component: () =>
            import('@/views/chargingVoucherAgency/specialCoupon.vue'),
          meta: {
            title: '特惠券包'
          }
        }
      ]
    },
    {
        path: '/applicat',
        name: 'applicat',
        component: () => import('@/views/paic/index.vue'),
        meta: {
          title: ''
        }
    },
    {
        path: '/test',
        name: 'test',
        component: () => import('@/views/paic/test.vue'),
        meta: {
          title: '测试通信'
        }
    },
    {
        path: '/tooth',
        name: 'tooth',
        component: () => import('@/views/paic/tooth.vue'),
        meta: {
          title: ''
        }
    },
    {
        path: '/myAccount',
        name: 'myAccount',
        component: () => import('@/views/app/my-account.vue'),
        meta: {
          title: '我的账户'
        }
    },
    {
      path: '/learnCenter', // 文章分类列表
      name: 'learnCenter',
      component: () => import('@/views/learnCenter/index.vue'),
      meta: {
        title: '学习中心'
      }
    },
    {
      path: '/articleList', // 文章列表
      name: 'articleList',
      component: () => import('@/views/learnCenter/article-list.vue'),
      meta: {
        title: '系统操作'
      }
    },
    {
      path: '/articleDetail', // 文章详情
      name: 'articleDetail',
      component: () => import('@/views/learnCenter/article-detail.vue'),
      meta: {
        title: '学习中心'
      }
    }
  ]
});
